import { ScriptModel } from '@/types';
import { BaseService } from '@/services';

class ScriptService extends BaseService<ScriptModel> {}

export default new ScriptService('scripts');
